import { useApiDeleteRequest } from '../hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '../hooks/useApiPatchRequest';
import { useApiPostRequest } from '../hooks/useApiPostRequest';
import {
  DELETE_ORGANIZATION_ANNOTATIONS_PATH,
  DeleteOrganizationAnnotationsErrorDto,
  DeleteOrganizationAnnotationsPathVariables,
  DeleteOrganizationAnnotationsQueryParams,
  DeleteOrganizationAnnotationsSuccessDto,
  PATCH_ORGANIZATION_ANNOTATIONS_PATH,
  PatchOrganizationAnnotationsBody,
  PatchOrganizationAnnotationsErrorDto,
  PatchOrganizationAnnotationsPathVariables,
  PatchOrganizationAnnotationsQueryParams,
  PatchOrganizationAnnotationsSuccessDto,
  POST_ORGANIZATION_ANNOTATIONS_PATH,
  PostOrganizationAnnotationsBody,
  PostOrganizationAnnotationsErrorDto,
  PostOrganizationAnnotationsPathVariables,
  PostOrganizationAnnotationsQueryParams,
  PostOrganizationAnnotationsSuccessDto,
} from './types/conversation';

export const usePostAnnotation = () => {
  return useApiPostRequest<
    PostOrganizationAnnotationsPathVariables,
    PostOrganizationAnnotationsQueryParams,
    PostOrganizationAnnotationsBody,
    PostOrganizationAnnotationsSuccessDto,
    PostOrganizationAnnotationsErrorDto
  >(POST_ORGANIZATION_ANNOTATIONS_PATH);
};

export const usePatchAnnotation = () => {
  return useApiPatchRequest<
    PatchOrganizationAnnotationsPathVariables,
    PatchOrganizationAnnotationsQueryParams,
    PatchOrganizationAnnotationsBody,
    PatchOrganizationAnnotationsSuccessDto,
    PatchOrganizationAnnotationsErrorDto
  >(PATCH_ORGANIZATION_ANNOTATIONS_PATH);
};

export const useDeleteAnnotation = () => {
  return useApiDeleteRequest<
    DeleteOrganizationAnnotationsPathVariables,
    DeleteOrganizationAnnotationsQueryParams,
    DeleteOrganizationAnnotationsSuccessDto,
    DeleteOrganizationAnnotationsErrorDto
  >(DELETE_ORGANIZATION_ANNOTATIONS_PATH);
};
